import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import About from './pages/About';
import Services from './pages/Services';
import Testimonials from './pages/Testimonials';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';
import LoadingSpinner from './components/LoadingSpinner'; // Import the spinner component

const App = () => {
    const [isLoading, setIsLoading] = useState(true); // State to control the spinner visibility

    useEffect(() => {
        // Simulate loading (replace this with actual data loading or fetching logic)
        setTimeout(() => {
            setIsLoading(false); 
        }, 500);
    }, []);

    return (
        <Router>
            <div className="app-container">
                {/* Show the Loading Spinner while isLoading is true */}
                <LoadingSpinner isLoading={isLoading} />

                {/* Include Header for all pages */}
                <Header />

                {/* Main Content Area */}
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/Contact" element={<Contact />} />
                        <Route path="/About" element={<About />} />
                        <Route path="/Services" element={<Services />} />
                        <Route path="/Testimonials" element={<Testimonials />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        {/* Fallback Route for 404 */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>

                {/* Include Footer for all pages */}
                <Footer />
            </div>
        </Router>
    );
};

export default App;
